"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var prop_types_1 = __importDefault(require("prop-types"));

var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: \"Nunito Sans\", sans-serif;\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  height: 20px;\n"], ["\n  font-family: \"Nunito Sans\", sans-serif;\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  height: 20px;\n"])));
var Label = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 14px;\n  margin-left: 10px;\n  cursor: pointer;\n"], ["\n  font-size: 14px;\n  margin-left: 10px;\n  cursor: pointer;\n"])));
var Svg = styled_components_1.default("div")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  display: block;\n  top: 5%;\n  left: 6px;\n  color: white;\n  .check {\n    fill: white;\n  }\n  .minus {\n    fill: #cccccc;\n  }\n"], ["\n  position: absolute;\n  display: block;\n  top: 5%;\n  left: 6px;\n  color: white;\n  .check {\n    fill: white;\n  }\n  .minus {\n    fill: #cccccc;\n  }\n"])));
var Input = styled_components_1.default.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  all: unset;\n  border: none;\n  background: none;\n  width: 20px;\n  height: 20px;\n  display: block;\n  border-radius: 3px;\n  border: 3px solid #dfdfdf;\n  transition: all 0.2s ease-in-out;\n  &:checked {\n    border: 3px solid #2d4ef5;\n    background-color: #2d4ef5;\n  }\n  &:hover {\n    border-color: ", ";\n  }\n  background-color: ", ";\n  border-color: ", ";\n"], ["\n  all: unset;\n  border: none;\n  background: none;\n  width: 20px;\n  height: 20px;\n  display: block;\n  border-radius: 3px;\n  border: 3px solid #dfdfdf;\n  transition: all 0.2s ease-in-out;\n  &:checked {\n    border: 3px solid #2d4ef5;\n    background-color: #2d4ef5;\n  }\n  &:hover {\n    border-color: ", ";\n  }\n  background-color: ", ";\n  border-color: ", ";\n"])), function (props) {
  return props.disabled ? "#E5E5E5" : "#2d4ef5";
}, function (props) {
  return props.disabled ? "#E5E5E5" : "none";
}, function (props) {
  return props.disabled ? "#E5E5E5" : "#dfdfdf";
});

exports.Checkbox = function (_a) {
  var label = _a.label,
      id = _a.id,
      name = _a.name,
      checked = _a.checked,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      className = _a.className;
  return react_1.default.createElement(Container, {
    className: className
  }, react_1.default.createElement(Input, {
    type: "checkbox",
    id: id,
    name: name,
    checked: checked,
    disabled: disabled
  }), react_1.default.createElement(Svg, {
    checked: checked
  }, checked && !disabled ? react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    className: "check"
  }, react_1.default.createElement("path", {
    d: "M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z"
  })) : null, disabled && !checked ? react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    className: "minus"
  }, react_1.default.createElement("path", {
    d: "M0 10h24v4h-24z"
  })) : null), label ? react_1.default.createElement(Label, {
    htmlFor: id
  }, label) : null);
};

exports.Checkbox.propTypes = {
  label: prop_types_1.default.string.isRequired,
  id: prop_types_1.default.string.isRequired,
  name: prop_types_1.default.string.isRequired,
  checked: prop_types_1.default.bool.isRequired,
  disabled: prop_types_1.default.bool,
  className: prop_types_1.default.string
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;